import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Components, GameState } from 'macguffin'
import { openSettingsScreen } from 'macguffin/redux/actions'
import GameControls from './components/GameControls'
import PopupScreens from './components/popups/PopupScreens'
import Settings from './components/settings'
import Fullscreen from './components/fullscreen'
import uiReducer from './redux/reducer'
import Sagas from './redux/sagas'
import { onResize, setPopupScreen, uiButtonPressed } from './redux/actions'
import { UI } from './devTools'
import DimensionsZone from './devTools/ui/dimensionsZone'
import WaitForConnection from './components/popups/waitForConnection'
import DefaultSvgSheet from './components/svg/SvgToJsxSheet.jsx'
import { stopPropagation, useComponentWillMount } from './utils'
import { BUTTON_CLOSE } from './redux/constants'

const { PopupMessage } = Components
const { toggleSettings } = GameState.Actions

const formatStyle = {
  showCurrency: false,
  useSeparators: true,
  showSubUnits: true
}

const UiComponent = props => {
  const svgIcons = useRef(false)

  useComponentWillMount(() => {
    require('./style/style.less')
    require('./style/locales.less')
    require('./style/swipe.less')
    require('./style/svg.less')

    window.addEventListener('pointerup', onTouchEnd, true)
    window.addEventListener('mouseup', onTouchEnd, true)
    window.addEventListener('resize', props.onResize)
    props.onResize()

    const sheetToUse = (props.GameSvgSheet && props.GameSvgSheet()) || DefaultSvgSheet()
    svgIcons.current = sheetToUse.props.children
  })

  const onTouchEnd = (e) => {
    if (props.message) {
      stopPropagation(e)
      e.stopImmediatePropagation()
      const svgAncestor = e.target.closest('.svg-icon')
      if (e.target.click) {
        e.target.click()
      } else if (svgAncestor) {
        svgAncestor.dispatchEvent(new CustomEvent('onClickForIosDelay', e))
      }
      return false
    }
  }

  useEffect(() => {
    return () => {
      window.removeEventListener('pointerup', onTouchEnd)
      window.removeEventListener('mouseup', onTouchEnd)
      window.removeEventListener('resize', props.onResize)
    }
  }, [])

  const closePopup = () => {
    props.setPopupScreen(null)
    props.openSettingsScreen(null)
    props.uiButtonPressed(BUTTON_CLOSE)
  }

  const { messages, settingScreen, orientationChecked, demomode,
    loadedLocale, noFullscreen, loading, hasSplash,
    hideSplash, dimensionsDebug, waitingForConnection, dimensions,
    popupScreen } = props

  if (loading || (hasSplash && !hideSplash)) {
    return <div />
  }

  const hasMessage = messages.length > 0
  const activateHitbox = popupScreen || settingScreen
  const activateBlur = dimensions.desktopUI && !settingScreen ? ' blur' : ''
  const enablePointerEvents = dimensions.desktopUI && !settingScreen && !popupScreen ? ' enable-pointer-events' : ''
  const gameControlProps = {
    formatStyle,
    svgIcons: svgIcons.current,
  }
  const { height, width } = dimensions

  return (
    <div className="gameUI" key={loadedLocale} style={{ width, height }}>

      {activateHitbox && <div className={`hitbox ${dimensions.desktopUI && settingScreen ? 'blur' : ''}`} onClick={closePopup} />}

      {settingScreen && (
        <div
          className="dialogue"
          onTouchMove={e => hasMessage && stopPropagation(e)}
          onClick={() => !hasMessage && closePopup()}
          style={{ width, height }}
        >
          <Settings pages={props.SettingsPages} svgIcons={svgIcons.current} />
        </div>
      )}

      {popupScreen && <PopupScreens {...gameControlProps} />}

      <div className={`keypadUI${activateBlur}${enablePointerEvents}`} >
        <GameControls {...gameControlProps} />
      </div>

      {hasMessage && (
        <React.Fragment>
          <div className="overlay" />
          <div className="dialogue message" onTouchMove={e => hasMessage && stopPropagation(e)}>
            <PopupMessage message={messages[0]} />
          </div>
        </React.Fragment>
      )}

      <div>
        {!noFullscreen && !orientationChecked && <Fullscreen />}
      </div>

      <div>
        {waitingForConnection && <WaitForConnection />}
      </div>

      {dimensionsDebug && <DimensionsZone />}

    </div>
  )
}

const ConnectedUiComponent = connect(state => ({
  messages: state.base.messages,
  message: state.base.message,
  settingScreen: state.base.settingScreen,
  orientationChecked: state.base.orientationChecked,
  demomode: state.session.demomode,
  loadedLocale: state.session.loadedLocale,
  noFullscreen: state.session.noFullscreen,
  loading: state.base.loading,
  hideSplash: state.base.hideSplash,
  hasSplash: state.base.hasSplash,
  waitingForConnection: state.base.waitingForConnection,
  dimensions: state.UI.dimensions,
  dimensionsDebug: state.UI.dimensionsDebug,
  popupScreen: state.UI.popupScreen,
}), { toggleSettings, onResize, setPopupScreen, openSettingsScreen, uiButtonPressed })(UiComponent)

export default {
  Component: ConnectedUiComponent,
  Reducer: uiReducer,
  devTools: [UI],
  Sagas,
}